import { uz as uz$1 } from 'date-fns/locale';
import merge from 'lodash/merge';
import error from './error.js';
import login from './login.js';

var uz = {
  language: 'uz',
  country: 'uz',
  name: "O'zbek",
  embeddedLocale: merge(error, login),
  flags: ['UZ'],
  dateFns: uz$1,
  format: {
    date: 'd.MM.yyyy',
    dateTime: '$t(format:date) $t(format:time)',
    time: 'HH:mm',
  },
};

export { uz as default };
